import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

/** The Listen button's footprint while an item's audio and transcript are still being downloaded. */
const PLAY_BUTTON_WIDTH_PX = 110;
const PLAY_BUTTON_HEIGHT_PX = 28;

/**
 * What a message card shows before its content has downloaded: the Listen button's footprint and one line of text.
 *
 * Sized to the common loaded card, a short voice message, so the row measures the same before and after its content
 * lands and the list does not shift under a reader scrolling back through history.
 */
export default function FeedItemContentPlaceholder() {
  return (
    <Box sx={{ display: "flex", width: "100%", gap: 1, alignItems: "center" }} aria-hidden="true">
      <Skeleton
        variant="rounded"
        width={PLAY_BUTTON_WIDTH_PX}
        height={PLAY_BUTTON_HEIGHT_PX}
        sx={{ borderRadius: "50px" }}
      />
      <Skeleton variant="text" sx={{ flexGrow: 1, fontSize: "0.875rem" }} />
    </Box>
  );
}
